import { useNewCode } from '@calendly/feature-check-react'
import { useEffect, useMemo } from 'react'

import CookieService from 'services/cookie'

import { TRACKING_EVENT_NAMES } from './constants'
import { useTrack } from './useTrack'

export const useFeatureFlagEncountered = (flagKey, suppressAnalytics = false) => {
  const flag = useNewCode(flagKey, false)
  const FLAG_ENCOUNTERED_COOKIE_KEY = `${flagKey}_${flag?.variationKey}_encountered`
  const track = useTrack()

  const cookieService = useMemo(() => new CookieService(), [])

  useEffect(() => {
    const isFlagAlreadyEncountered = cookieService.getCookie(
      FLAG_ENCOUNTERED_COOKIE_KEY
    )

    if (!suppressAnalytics && flag?.variationKey === 'on' && isFlagAlreadyEncountered !== 'true') {
      cookieService.setCookie(FLAG_ENCOUNTERED_COOKIE_KEY, true)
      track({
        name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
        properties: {
          flag_key: flagKey,
          rule: flag?.rule,
          source: 'frontend',
          variation_key: flag.variationKey,
        },
      })
    }
  }, [suppressAnalytics, flag, flagKey, FLAG_ENCOUNTERED_COOKIE_KEY, cookieService, track])

  return flag?.enabled
}
